// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"aa778b5d","534":"1d1607e9","975":"049ff15e"}[chunkId] + ".chunk.js";
};